/* eslint quote-props: ["error", "as-needed", { "keywords": true, "unnecessary": false }] */

import ERROR_CODES from '@/constants/error-codes';

const TERMS_OF_USE = `
  我将接受以
  <a href="https://legal.motmom.com/documents/license" target="_blank"/>下条款与规定</a> 和
  同意 LLC Mo.Card整理我在此处的个人数据
  根据2006 年 7 月 27 日的关于个人数据的联邦法第 152-FZ 号作为公
  <a href="https://legal.motmom.com/documents/privacy" target="_blank">共数据条款</a>.
  我同意在我注册的手机号码和电子邮件地址中接收指定期间的信息、广告和其他消息。
`;

export default {
  authorize_title: '授权',
  sign_out_title: '退出',
  registration_title: '注册',
  password_restoration_title: '密码恢复',
  card_activation_title: '激活 <span style="color: #ccc;">MO.</sapn><span style="color: #707070;">CARD</sapn>',
  activation_title: '激活',

  input_subtitle: '输入',
  password_change_subtitle: '新的密码',
  email_verification_subtitle: '电子邮件',
  code_verification_subtitle: {
    phone: '短信代码',
    email: '电子邮件代码',
  },
  card_activation_subtitle: '输入号Mo.Card',

  incorrect_login: {
    login: '用户名错误',
    email: '邮箱错误',
    phone: '电话错误',
  },

  cant_be_empty: '不能为空',
  must_be_accepted: '可以通过',
  multilogin_placeholder_full: '电话号码或邮箱地址',
  multilogin_placeholder_small: '电话号码或是邮件',

  RatingPasswordTitle: '',
  weakRatingPasswordTitle: '弱度密码',
  mediumRatingPasswordTitle: '中等密码',
  strongRatingPasswordTitle: '强度密码',

  changePasswordDescription: {
    title: '建议使用:',
    length: '至少8个字符',
    numbers: '数字',
    lowercase: '小写字母',
    uppercase: '大写字母',
    symbols: '特殊符号',
  },

  sign_in: '登陆',
  sign_out: '退出',
  next: '下一个',
  cancel: '删除',
  allow: '允许',
  change: '更换',
  restration_submit: '报名',
  get_new_code: '获取新代码',
  code_accepted: '代码已接受',

  second_name: '中间名字',
  name: '名字',
  patronymic: '父姓',
  email: '邮箱地址',
  phone: '电话',
  city: '城市',
  country: '国家',

  password: '密码',
  forgot_password: '忘记密码?',
  remember_me: '记住密码',
  correct_the_mistake: '更正错误',
  incorrect_login_or_password: '错误的账号或密码',
  incorrect_email: '错误的邮箱地址',
  error_on_server: '不明确的错误',
  need_select_date: '请选择日期',
  not_found: '未找到匹配项',

  authorize_footer_text: {
    please_authorize: '请登录 ',
    if_no: '如果您没有 ',
    profile: ' 账户, ',
    registter: ' 注册 ',
    or: ' 或者 ',
    activate_card: ' 激活您的Mo.Card',
  },

  email_and_phone_verification_text: '请输入您的电子邮件或电话号码用来申请验证码，在您将收到一封包含验证码的电子邮件或短信后，务必在页面的方格中输入并确认该验证码。',

  email_verification_text: '输入您的电子邮件地址并点击“下一步”后，您将收到一封电子邮件，包含下一步需要填写的验证码',

  code_verification_text: '一封包含着验证码的邮件已经发送到您提供的邮箱',
  request_new_code_avilible: '您可以获取新的验证码',
  email_verification_success_text: '成功! ',
  email_verification_go_to_registration: '前往注册',
  email_verification_go_to_restoration: '前往退回',

  card_activation_text: {
    less_two_minutes: '激活时间不会超过2分钟',
    already_activated: '是否曾经激活过？',
    sign_in: ' 登陆',
    input_activation_code: '输入激活码',
    your_card_has_been_activated: '您的Mo.Card已被激活!',
    wrong_code: ' - 代码错误',
    code_on_card: '激活码在您的Mo.Card背面',
    all_right: '好了，请前往注册',
  },

  skip_activation: {
    link_name: '如果无需Mo.Card，忽略并登陆',
    can_bind_card_anytime: '您可以随时在您的个人账户上绑定',
  },

  activation_registration_text: {
    success_now_register: 'Mo.Card已被激活，请注册',
    enter_email: '输入您的邮箱账号',
  },

  authorize_success: {
    success: '成功登录! ',
    will_be_redirect: '您将被转到 ',
  },

  sign_out_success: {
    success: '成功退出! ',
    will_be_redirect: '您将被转到 ',
  },

  oauth2_success: {
    success: '已被授权!',
    will_be_redirect: '您将被转到 ',
  },

  registration_success: {
    success: '注册成功! ',
    wellcome: '欢迎来到 Motmom-在您城市里您最喜欢的地方享受利好政策与积分.',
    will_be_redirect: '您将被转到 ',
  },

  restore_success: {
    success: '密码已恢复! ',
    will_be_redirect: '您将被转到 ',
  },

  birthday: {
    title: '生日',
    year: '年份',
    month: '月份',
    day: '日期',
  },

  genders: {
    female: '女性 W',
    male: '男性 M',
  },

  authTermsOfUse: `<span style="line-height: 20px;  color: gray;">点击登录, ${TERMS_OF_USE}</span>`,

  initialTermsOfUse: `<span style="line-height: 20px;  color: gray;">点击注册，${TERMS_OF_USE}</span>`,

  termsOfUse: `<span style="line-height: 20px;  color: gray;">点击注册，${TERMS_OF_USE}</span>`,

  oauth2_change_account: '更改账户',
  oauth2_title: {
    access: '允许 ',
    use_account: ' 申请使用您的账户?',
  },

  oauth2_policy: {
    i_confirm: ' 我同意将此处的信息从资源 motmom.com 的所有者转到 ',

    i_also_confirm: ' 我还同意“、”的所有者对我个人数据进行后续处理 ',

    i_realize: ' 应用程序。我了解指定资源是公开可用的信息源，并且我同意在考虑资源的指定功能的情况下处理数据。个人数据的处理和撤销个人数据处理的同意是根据资源隐私政策的条款进行的',

    i_full_confirm: '我已阅读并完全同意条款内容',

    i_conset_personal_data_transfer: ['我同意使用我的手机号码和电子邮件信箱，以便通过指定的手机号码和电子邮件地址接收来自', '应用程序信息、广告和其他消息。'],

  },

  cookie_notice_text: {
    header: 'COOKIES 的使用',
    we_use_cookie: '我们需要使用对于我们网站正常运行至关重要的cookie。此外，我们的网站以及第三方公司 Google 和 Yandex 通过 cookie 来分析受众群体及其行为。您可以通过点击“详细信息”了解有关我们 cookie 政策的更多信息',

    if_you_accept: '如果您同意使用所有cookie，请点击“全部接受”。如果您反对使用cookie，请点击“只接受必要的”。.',

    accept_all: '全部接受',
    accept_necessary: '只接受必要的',
    more_info: '详细信息',
  },

  cookie_policy_text: {
    use_cooki_files: 'Cookie 政策',
    necessary_cookie: '必要的Cookies',
    policy_about_cookie_files: 'Cookie政策',
    about_necessary_cookie: '必要的 cookie 包括安全性和可访问性等基本功能。您可以通过更改浏览器设置来禁用它们，但这可能会影响网站的正常工作。 ',

    we_use_next_necessary_cookie: '我们使用以下（技术）必要的Cookie:',
    necessary_cookie_list: [
      {
        cookie: 'cookies_usage_confirmation, is_additional_cookies_accepted',
        description: '这些 cookie 包含选择使用 cookie的用户 或不做出选择的用户的信息',

      },
      {
        cookie: 'MOSSID',
        description: '这些 cookie 包含用于在服务过程中身份验证的信息',

      },
    ],
    analytics_cookie: '分析Cookie',
    why_analytics: '我们和我们的合作伙伴使用分析 Cookie，通过收集和报告有关您如何使用网站的信息来帮助我们改进网站。 Cookie 收集信息的方式使我们无法识别您的身份。使用此类 cookie 获得的信息可供第三方使用，特别是 Yandex。',

    we_use_next_analytics_cookie: '我们使用以下来分析cookie:',
    analytics_cookie_list: [
      {
        cookie: 'IDE',
        description: '此 cookie 包含有关最终用户如何使用该网站的信息以及最终用户在访问该网站之前可能看到的任何广告。',
      },
      {
        cookie: '_ym_d',
        description: '此 cookie 与 Yandex Metrica 相关联，包含用户首次访问该网站的日期。',
      },

      {
        cookie: '_ym_isad',
        description: '此 cookie 与 Yandex Metrica 关联，并确定用户是否启用了广告拦截器。',
      },

      {
        cookie: '_ym_uid',
        description: '此 cookie 与 Yandex Metrica 相关联。此 cookie 用于通过分配随机生成的数字作为客户 ID 来识别唯一用户。',
      },

      {
        cookie: '_ym_visorc_XXXXXXXX',
        description: '此 cookie 与 Yandex Metrica 关联，包含网络查看器的标识符，并允许会话播放正常工作。',
      },
      {
        cookie: 'i; yandexuid',
        description: '此 cookie 与 Yandex Metrica 相关联。该 cookie 允许您区分访客。',
      },

      {
        cookie: 'yabs-sid',
        description: '此 cookie 与 Yandex Metrica 相关联。该 cookie 用作访客识别。 ',

      },
      {
        cookie: 'yp',
        description: '此 cookie 与 Yandex Metrica 相关联，此 cookie 用作存储持久性门户数据的任务。',

      },
      {
        cookie: 'ys',
        description: '此 cookie 与 Yandex Metrica 相关联。该cookie用作存储门户会话数据的任务。 ',

      },
      {
        cookie: 'mda',
        description: '此 cookie 与 Yandex Metrica 相关联。该cookie用于多个身份验证。 ',

      },
      {
        cookie: 'ymex',
        description: '此 cookie 与 Yandex Metrica 相关联。该 cookie 用于广告、帮助区分用户、用于分析平台和网站、测量和分析网络流量。 ',
      },
      {

        cookie: 'yuidss',
        description: '此 cookie 与 Yandex Metrica 相关联。此 cookie 收集有关多个站点访问者行为的信息。网站上使用这些信息来优化广告的相关性。 ',
      },

    ],
    more_about_cookie_policy: '有关我们如何处理 cookie 的更多信息，请参阅 <a href="https://legal.motmom.com/documents/privacy" style="color: gray;">隐私政策。</a> ',
    control_policy_of_analitycs_cookie: '管理分析 cookie 设置',

    i_agree: '我同意搜集分析',
    i_degree: '我不同意搜集分析',
    save_button_text: '保存设置',
    select_error: '未选择任何内容',
  },

  errors_messages: {
    [ERROR_CODES.MISSING_USER]: '用户不存在',
    [ERROR_CODES.TOO_MANY_REQUESTS]: '过多的申请',
    [ERROR_CODES.TOO_MANY_ATTEMPTS]: '您已经超出了最多点击次数。稍后再试。',
    [ERROR_CODES.INVALID_UNIQUE_KEY]: '无效唯一密码，稍后再试',
    [ERROR_CODES.INVALID_VERIFICATION_CODE]: '验证码无效或过期',
    [ERROR_CODES.MIXED_PARAMS]: '短信代码和密码混淆',
    [ERROR_CODES.INVALID_PASSWORD]: '无效密码',
    [ERROR_CODES.EMAIL_NOT_CONFIRMED]: '此电子邮件地址未经确认。您可以尝试使用您的电话号码恢复您的账户或联系技术支持。',
    [ERROR_CODES.ERROR_ATTEMPT_LIMIT]: '尝试次数过多，请稍后再试',

    [ERROR_CODES.INVALID_CARD_NUMBER]: '此号码的Mo.Card不存在',

    [ERROR_CODES.ERROR_CARD_ALREADY_ACTIVATED]: '此号码的Mo.Card已被激活使用',

    [ERROR_CODES.INVALID_ACTIVATION_CODE]: '无效的激活码',
    [ERROR_CODES.INVALID_SMS_CODE]: '无效代码',
    [ERROR_CODES.ERROR_EMAIL_SENDING_TIMEOUT]: '尝试次数过多，请稍后再试',
    [ERROR_CODES.INVALID_BIRTHDAY]: '无效生日日期',

    [ERROR_CODES.INVALID_IDENTIFIER]: '无效的电话号码或是电子邮件地址',
    [ERROR_CODES.ERROR_INVALID_EMAIL]: '无效电子邮件地址',
    [ERROR_CODES.ERROR_EMAIL_EXISTS]: '此电子邮件地址已被注册',
    [ERROR_CODES.ERROR_INVALID_PASSWORD]: '无效密码',
    [ERROR_CODES.UNKNOWN_SERVER_ERROR]: '出现未知错误。刷新页面并再次操作或联系技术人员。',


    [ERROR_CODES.INVALID_USER_OR_PASSWORD]: '无效用户或密码',
    [ERROR_CODES.USER_NOT_FOUND]: '用户未找到',
    [ERROR_CODES.USER_IS_BLOCKED]: '用户被锁',
    [ERROR_CODES.PHONE_EXISTS]: '电话号码已被注册',
    [ERROR_CODES.PASSWORD_RESTORATION_REQUIRED]: '密码恢复',
    [ERROR_CODES.EMAIL_SENDER_ERROR]: '发送带有恢复代码的电子邮件时出错，请稍后再试',
    [ERROR_CODES.ERROR_EMAIL_OR_PASSWORD_NOT_FOUND]: '邮件地址或密码错误',
    [ERROR_CODES.ERROR_PHONE_NUMBER_OR_PASSWORD_NOT_FOUND]: '电话号码或密码错误',
    [ERROR_CODES.ERROR_CARD_NUMBER_OR_PASSWORD_NOT_FOUND]: '卡号或密码错误',
    [ERROR_CODES.ERROR_INVALID_USERNAME]: '无效的用户名',
  },

  country_name: {
    'AF': 'Afghanistan',
    'AL': 'Albania',
    'DZ': 'Algeria',
    'AS': 'American Samoa',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AQ': 'Antarctica',
    'AG': 'Antigua and Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AW': 'Aruba',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaijan',
    'BS': 'Bahamas',
    'BH': 'Bahrain',
    'BD': 'Bangladesh',
    'BB': 'Barbados',
    'BY': 'Belarus',
    'BE': 'Belgium',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BM': 'Bermuda',
    'BT': 'Bhutan',
    'BO': 'Bolivia',
    'BA': 'Bosnia and Herzegovina',
    'BW': 'Botswana',
    'BV': 'Bouvet Island',
    'BR': 'Brazil',
    'IO': 'British Indian Ocean Territory',
    'BN': 'Brunei Darussalam',
    'BG': 'Bulgaria',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'KH': 'Cambodia',
    'CM': 'Cameroon',
    'CA': 'Canada',
    'CV': 'Cape Verde',
    'KY': 'Cayman Islands',
    'CF': 'Central African Republic',
    'TD': 'Chad',
    'CL': 'Chile',
    'CN': 'China',
    'CX': 'Christmas Island',
    'CC': 'Cocos (Keeling) Islands',
    'CO': 'Colombia',
    'KM': 'Comoros',
    'CG': 'Congo',
    'CD': 'Congo, the Democratic Republic of the',
    'CK': 'Cook Islands',
    'CR': 'Costa Rica',
    'CI': 'Cote D\'Ivoire',
    'HR': 'Croatia',
    'CU': 'Cuba',
    'CY': 'Cyprus',
    'CZ': 'Czech Republic',
    'DK': 'Denmark',
    'DJ': 'Djibouti',
    'DM': 'Dominica',
    'DO': 'Dominican Republic',
    'EC': 'Ecuador',
    'EG': 'Egypt',
    'SV': 'El Salvador',
    'GQ': 'Equatorial Guinea',
    'ER': 'Eritrea',
    'EE': 'Estonia',
    'ET': 'Ethiopia',
    'FK': 'Falkland Islands (Malvinas)',
    'FO': 'Faroe Islands',
    'FJ': 'Fiji',
    'FI': 'Finland',
    'FR': 'France',
    'GF': 'French Guiana',
    'PF': 'French Polynesia',
    'TF': 'French Southern Territories',
    'GA': 'Gabon',
    'GM': 'Gambia',
    'GE': 'Georgia',
    'DE': 'Germany',
    'GH': 'Ghana',
    'GI': 'Gibraltar',
    'GR': 'Greece',
    'GL': 'Greenland',
    'GD': 'Grenada',
    'GP': 'Guadeloupe',
    'GU': 'Guam',
    'GT': 'Guatemala',
    'GN': 'Guinea',
    'GW': 'Guinea-Bissau',
    'GY': 'Guyana',
    'HT': 'Haiti',
    'HM': 'Heard Island and McDonald Islands',
    'VA': 'Holy See (Vatican City State)',
    'HN': 'Honduras',
    'HK': 'Hong Kong',
    'HU': 'Hungary',
    'IS': 'Iceland',
    'IN': 'India',
    'ID': 'Indonesia',
    'IR': 'Iran, Islamic Republic of',
    'IQ': 'Iraq',
    'IE': 'Ireland',
    'IL': 'Israel',
    'IT': 'Italy',
    'JM': 'Jamaica',
    'JP': 'Japan',
    'JO': 'Jordan',
    'KZ': 'Kazakhstan',
    'KE': 'Kenya',
    'KI': 'Kiribati',
    'KP': 'North Korea',
    'KR': 'South Korea',
    'KW': 'Kuwait',
    'KG': 'Kyrgyzstan',
    'LA': 'Lao People\'s Democratic Republic',
    'LV': 'Latvia',
    'LB': 'Lebanon',
    'LS': 'Lesotho',
    'LR': 'Liberia',
    'LY': 'Libya',
    'LI': 'Liechtenstein',
    'LT': 'Lithuania',
    'LU': 'Luxembourg',
    'MO': 'Macao',
    'MG': 'Madagascar',
    'MW': 'Malawi',
    'MY': 'Malaysia',
    'MV': 'Maldives',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Marshall Islands',
    'MQ': 'Martinique',
    'MR': 'Mauritania',
    'MU': 'Mauritius',
    'YT': 'Mayotte',
    'MX': 'Mexico',
    'FM': 'Micronesia, Federated States of',
    'MD': 'Moldova, Republic of',
    'MC': 'Monaco',
    'MN': 'Mongolia',
    'MS': 'Montserrat',
    'MA': 'Morocco',
    'MZ': 'Mozambique',
    'MM': 'Myanmar',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Netherlands',
    'NC': 'New Caledonia',
    'NZ': 'New Zealand',
    'NI': 'Nicaragua',
    'NE': 'Niger',
    'NG': 'Nigeria',
    'NU': 'Niue',
    'NF': 'Norfolk Island',
    'MK': 'North Macedonia, Republic of',
    'MP': 'Northern Mariana Islands',
    'NO': 'Norway',
    'OM': 'Oman',
    'PK': 'Pakistan',
    'PW': 'Palau',
    'PS': 'Palestine',
    'PA': 'Panama',
    'PG': 'Papua New Guinea',
    'PY': 'Paraguay',
    'PE': 'Peru',
    'PH': 'Philippines',
    'PN': 'Pitcairn',
    'PL': 'Poland',
    'PT': 'Portugal',
    'PR': 'Puerto Rico',
    'QA': 'Qatar',
    'RE': 'Reunion',
    'RO': 'Romania',
    'RU': 'Russian Federation',
    'AC': 'Ascension island',
    'RW': 'Rwanda',
    'SH': 'Saint Helena',
    'KN': 'Saint Kitts and Nevis',
    'LC': 'Saint Lucia',
    'PM': 'Saint Pierre and Miquelon',
    'VC': 'Saint Vincent and the Grenadines',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'Sao Tome and Principe',
    'SA': 'Saudi Arabia',
    'SN': 'Senegal',
    'SC': 'Seychelles',
    'SL': 'Sierra Leone',
    'SG': 'Singapore',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'SB': 'Solomon Islands',
    'SO': 'Somalia',
    'ZA': 'South Africa',
    'GS': 'South Georgia and the South Sandwich Islands',
    'ES': 'Spain',
    'LK': 'Sri Lanka',
    'SD': 'Sudan',
    'SR': 'Suriname',
    'SJ': 'Svalbard and Jan Mayen',
    'SZ': 'Eswatini',
    'SE': 'Sweden',
    'CH': 'Switzerland',
    'SY': 'Syrian Arab Republic',
    'TW': 'Taiwan',
    'TJ': 'Tajikistan',
    'TZ': 'Tanzania, United Republic of',
    'TH': 'Thailand',
    'TL': 'Timor-Leste',
    'TG': 'Togo',
    'TK': 'Tokelau',
    'TO': 'Tonga',
    'TT': 'Trinidad and Tobago',
    'TN': 'Tunisia',
    'TR': 'Turkey',
    'TM': 'Turkmenistan',
    'TC': 'Turks and Caicos Islands',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukraine',
    'AE': 'United Arab Emirates',
    'GB': 'United Kingdom',
    'US': 'United States of America',
    'UM': 'United States Minor Outlying Islands',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistan',
    'VU': 'Vanuatu',
    'VE': 'Venezuela',
    'VN': 'Vietnam',
    'VG': 'Virgin Islands, British',
    'VI': 'Virgin Islands, U.S.',
    'WF': 'Wallis and Futuna',
    'EH': 'Western Sahara',
    'YE': 'Yemen',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe',
    'AX': 'Åland Islands',
    'BQ': 'Bonaire, Sint Eustatius and Saba',
    'CW': 'Curaçao',
    'GG': 'Guernsey',
    'IM': 'Isle of Man',
    'JE': 'Jersey',
    'ME': 'Montenegro',
    'BL': 'Saint Barthélemy',
    'MF': 'Saint Martin (French part)',
    'RS': 'Serbia',
    'SX': 'Sint Maarten (Dutch part)',
    'SS': 'South Sudan',
    'XK': 'Kosovo',
  },
};
